var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "mobile-offers" } },
    [
      _c("div", { staticClass: "row px-1" }, [
        _c("div", { staticClass: "col-12 px-0" }, [
          _c("h2", {
            staticClass: "h3 mb-md-2 mb-1",
            domProps: { innerHTML: _vm._s(_vm.mobileOffersData.titleHtml) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 px-0" }, [
          _c("div", { staticClass: "container mw-100 mb-1" }, [
            _c("div", { staticClass: "row px-0" }, [
              _c(
                "div",
                { staticClass: "col-12 px-0" },
                [
                  _c(
                    "swiper-container",
                    {
                      attrs: {
                        "uniq-swiper-id": "mobileOffersSwiper1",
                        "slides-per-view": _vm.swiperSlidesPerView,
                        "space-between": _vm.swiperSpaceBetween,
                        pagination: _vm.swiperPagination,
                        navigation: _vm.swiperNavigation,
                        "update-navigation-position-in-screen":
                          _vm.swiperUpdateNavigationPositionInScreen,
                        breakpoints: _vm.swiperBreakpoints,
                      },
                    },
                    [
                      _vm._l(
                        _vm.offersTilesWithUpdatedFoLink,
                        function (offer) {
                          return _c(
                            "swiper-slide",
                            {
                              key: JSON.stringify(offer),
                              attrs: {
                                "is-initial-swiper-slide":
                                  offer.seoId === _vm.selectedMobileOfferSeoId,
                              },
                            },
                            [
                              _c("MobileOfferTile", {
                                attrs: {
                                  offer: offer,
                                  "selected-mobile-offer-seo-id":
                                    _vm.selectedMobileOfferSeoId,
                                },
                                on: { "select-offer": _vm.selectOffer },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                      _vm._v(" "),
                      _vm.mobileOffersData.edito5gTile
                        ? _c(
                            "swiper-slide",
                            { staticClass: "swiper-slide-height" },
                            [
                              _vm.mobileOffersData.edito5gTile
                                ? _vm._m(0)
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("MobileEditoTile", {
      attrs: {
        "title-html": _vm.mobileOffersData.edito5gTile.titleHtml,
        "show-picto5-g": _vm.mobileOffersData.edito5gTile.showPicto5G,
        "picto5g-src": _vm.mobileOffersData.edito5gTile.picto5gSrc,
        attributes: _vm.mobileOffersData.edito5gTile.attributes,
        "link-label": _vm.mobileOffersData.edito5gTile.linkLabel,
        link: _vm.mobileOffersData.edito5gTile.link,
        "link-tms": _vm.mobileOffersData.edito5gTile.linkTms,
      },
    })
  },
]
render._withStripped = true

export { render, staticRenderFns }